import { useMemo } from 'react';
import { IMessage } from '.';

export const useMessage = (message?: IMessage) => {
  const messageStyle = useMemo(
    () => ({
      backgroundColor: message?.backgroundColor,
      color: message?.textColor,
    }),
    [message],
  );

  const headerStyleDesktop = useMemo(
    () => ({
      fontSize: message?.header.fontSizeDesktop,
    }),
    [message],
  );

  const headerStyleMobile = useMemo(
    () => ({
      fontSize: message?.header.fontSizeMobile,
    }),
    [message],
  );

  const subHeaderStyleDesktop = useMemo(
    () => ({
      fontSize: message?.subHeader?.fontSizeDesktop,
    }),
    [message],
  );

  const subHeaderStyleMobile = useMemo(
    () => ({
      fontSize: message?.subHeader?.fontSizeMobile,
    }),
    [message],
  );

  return {
    enabled: !!message,
    header: message?.header.text,
    headerStyleDesktop,
    headerStyleMobile,
    messageStyle,
    subHeader: message?.subHeader?.text,
    subHeaderStyleDesktop,
    subHeaderStyleMobile,
  };
};
